
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#185C37","d":"M12.558 9.837 4.651 8.442v10.31c0 .47.382.853.853.853h13.644c.47 0 .852-.382.852-.853v-3.798z"}}),_c('path',{attrs:{"fill":"#21A366","d":"M12.558 1H5.504a.853.853 0 0 0-.853.853V5.65l7.907 4.651 4.186 1.396L20 10.302v-4.65z"}}),_c('path',{attrs:{"fill":"#107C41","d":"M4.651 5.651h7.907v4.651H4.651z"}}),_c('path',{attrs:{"fill":"#000","d":"M10.31 4.72H4.651V16.35h5.66a.855.855 0 0 0 .852-.853V5.573a.855.855 0 0 0-.853-.852","opacity":".1"}}),_c('path',{attrs:{"fill":"#000","d":"M9.845 5.186H4.651v11.628h5.194a.855.855 0 0 0 .853-.853V6.04a.855.855 0 0 0-.853-.853","opacity":".2"}}),_c('path',{attrs:{"fill":"#000","d":"M9.845 5.186H4.651v10.698h5.194a.855.855 0 0 0 .853-.853V6.04a.855.855 0 0 0-.853-.853","opacity":".2"}}),_c('path',{attrs:{"fill":"#000","d":"M9.38 5.186H4.651v10.698H9.38a.855.855 0 0 0 .853-.853V6.04a.855.855 0 0 0-.853-.853","opacity":".2"}}),_c('path',{attrs:{"fill":"#117E43","d":"M.853 5.186H9.38c.47 0 .852.382.852.853v8.527c0 .47-.381.853-.852.853H.853A.853.853 0 0 1 0 14.566V6.039c0-.471.382-.853.853-.853"}}),_c('path',{attrs:{"fill":"#fff","d":"m2.64 13.074 1.794-2.78-1.643-2.763h1.322l.896 1.767q.125.252.17.375h.012q.09-.201.186-.39l.959-1.751h1.213l-1.685 2.747 1.728 2.794H6.301l-1.036-1.94a1.6 1.6 0 0 1-.124-.258h-.015q-.045.133-.12.25L3.94 13.075z"}}),_c('path',{attrs:{"fill":"#33C481","d":"M19.147 1h-6.589v4.651H20V1.853A.853.853 0 0 0 19.147 1"}}),_c('path',{attrs:{"fill":"#107C41","d":"M12.558 10.302H20v4.652h-7.442z"}})])
          )
        }
      }
    